import routePaths from "app/routePaths";
import Agent from "infrastructure/agent";
import config from "infrastructure/config";
import authService from "services/auth.service";
import { APP_ACTIONS } from "app/app.constants";
import { applicationOnLoad } from "app/app.actions";

export const loginPopup = () => dispatch => {
  const payload = authService.loginPopup(
    [config.scope],
    "&prompt=select_account",
  );

  dispatch({
    payload,
    type: APP_ACTIONS.LOGIN,
  });

  return payload.then(() => {
    // reset the Agent so that the access_token refreshes immediately after logging in
    Agent.throttledRefreshToken.cancel();

    return dispatch(applicationOnLoad());
  });
};

export const logout = () => dispatch => {
  const payload = new Promise(resolve => resolve(authService.logout()));

  dispatch({
    payload,
    type: APP_ACTIONS.LOGOUT,
  });

  return payload;
};

export const changeUser = () => dispatch => {
  dispatch(loginPopup()).then(() => {
    window.location = routePaths.root;
  });
};
